import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- Subscription ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/subscriptions/list',
    name: 'pages-subscriptions-list',
    component: () => import('@/views/pages/subscription/SubscriptionList.vue'),
    meta: {
      resource: 'subscription',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('users.mainVerticalMenu.subscriptions'),
    },
  },
  {
    path: '/subscriptions/edit/:id',
    name: 'pages-subscriptions-edit',
    component: () => import('@/views/pages/subscription/SubscriptionEdit.vue'),
    meta: {
      resource: 'subscription',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('users.mainVerticalMenu.editSubscriptions'),
    },
  },
]
